/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import R from 'ramda'
import moment from 'moment'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  Card,
  Subheader,
  ListItem,
  FontIcon,
  Checkbox,
  CircularProgress
} from 'material-ui'
import { red500, deepOrange500 } from 'material-ui/styles/colors'
import * as colors from 'utils/colors'

import * as constants from 'constants/Prestation'
import * as actions from 'actions/ApplicantPrestation'
import * as interpreterActions from 'actions/Interpreter'

import Availability from './Availability'

class InterpreterList extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)

    this.state = {
      availabilities: [],
      loadingAvailability: false
    }
  }

  componentDidMount() {
    if (this.props.isVisible && this.props.updateInterpreterSearch) {
      this.handleLoadMatchingInterpreters()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isVisible !== prevProps.isVisible ||
        this.props.updateInterpreterSearch !== prevProps.updateInterpreterSearch) {
      if (this.props.isVisible && this.props.updateInterpreterSearch) {
        let interpreters = []
        actions.getMatchingInterpreters(
          this.props.prestation,
          this.props.prestation.address.address,
          this.props.user.uid
        )
        .then((results) => {
          interpreters = results.data.objects.objects.filter(interpreter => interpreter.is_available_now)

          if (R.path(['uid'], this.props.prestation)) {
            if (!R.path(['interpreter', 'uid'], this.props.prestation)) {
              const interpreterUids = this.props.prestation.selected_interpreters.map(interpreter => interpreter.uid)
              interpreters = results.data.objects.objects.filter(interpreter => interpreterUids.indexOf(interpreter.uid) !== -1)
            } else {
              interpreters = results.data.objects.objects.filter(interpreter => interpreter.uid === this.props.prestation.interpreter.uid)
            }
          }

          this.handleLoadAvailabilities(results)
        })
        .finally(() => {
          this.props.handlePrestationChange('interpreters', interpreters)
          this.props.handleFormChange('showDetails', true)
          this.props.handleFormChange('updateInterpreterSearch', false)
        })
      }
    }
  }

  handleLoadMatchingInterpreters() {
    let interpreters = []
    actions.getMatchingInterpreters(
      this.props.prestation,
      this.props.prestation.address.address
    )
    .then((results) => {
      interpreters = results.data.objects.objects.filter(interpreter => interpreter.is_available_now)

      if (R.path(['uid'], this.props.prestation)) {
        if (!R.path(['interpreter', 'uid'], this.props.prestation)) {
          const interpreterUids = this.props.prestation.selected_interpreters.map(interpreter => interpreter.uid)
          interpreters = results.data.objects.objects.filter(interpreter => interpreterUids.indexOf(interpreter.uid) !== -1)
        } else {
          interpreters = results.data.objects.objects.filter(interpreter => interpreter.uid === this.props.prestation.interpreter.uid)
        }
      }

      this.handleLoadAvailabilities(results)
    })
    .finally(() => {
      this.props.handlePrestationChange('interpreters', interpreters)
      this.props.handleFormChange('showDetails', true)
      this.props.handleFormChange('updateInterpreterSearch', false)
    })
  }

  handleToggleSelected(event, value) {
    event.stopPropagation()

    const interpreters = []

    this.props.prestation.interpreters.map((interpreter, index) => {
      if (interpreter.uid === value.uid) {
        interpreter.selected = !interpreter.selected
      }

      return interpreters.push(interpreter)
    })

    this.props.handlePrestationChange('interpreters', interpreters)
  }

  handleLoadAvailabilities(matching) {
    const availabilities = interpreterActions.getInterpreterAvailabilities(matching)

    this.setState({
      availabilities: availabilities
    })
  }

  handleChangeAvailability(availability) {
    let availabilities = []
    this.setState({
      loadingAvailability: true
    })

    const prestation = {
      ...this.props.prestation,
      ordered_start_time: moment(availability.start).format('HH:mm'),
      ordered_end_time: moment(availability.end).format('HH:mm')
    }

    actions.getMatchingInterpreters(prestation, prestation.address.address, this.props.user.uid)
      .then((results) => {
        availabilities = interpreterActions.getInterpreterAvailabilities(results)
      })
      .finally(() => {
        this.setState({
          availabilities: availabilities,
          loadingAvailability: false
        })
      })
  }

  async handleTimeChange(availability) {
    await this.props.handlePrestationChange('ordered_start_time', moment(availability.start).format('HH:mm'))
    await this.props.handlePrestationChange('ordered_end_time', moment(availability.end).format('HH:mm'))
    this.props.handleFormChange('updateInterpreterSearch', true)
  }

  render() {
    if (!this.props.isVisible) {
      return (
        <div></div>
      )
    }

    return (
      <Card
        style={{
          ...styles.card,
          minHeight: !this.props.formVisible ? 660 : 475
        }}
      >
        {
          this.props.updateInterpreterSearch
            ? <CircularProgress
              size={200}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
            : <React.Fragment>
              <div
                className='row'
              >
                {
                  !this.props.prestation.interpreters.length &&
                  !this.state.availabilities.length
                    ? <div
                      className='col-xs-12'
                      style={{
                        color: red500,
                        height: '64%',
                        alignItems: 'center',
                        paddingTop: '25%',
                        textAlign: 'center',
                      }}
                    >
                      {this.props.intl.formatMessage(constants.messages.INTERPRETER_UNAVAILABLE_CRITERIAS)}
                      <a
                        href={"mailto:" + constants.MAIL_TO}
                        style={{color: red500}}
                      >
                        {constants.MAIL_TO}
                      </a>
                    </div>
                    : <React.Fragment>
                      {
                        !this.props.prestation.uid &&
                        !this.props.prestation.invoice_only_additional_services
                          ? <div
                            className='col-md-4 col-xs-4'
                          >
                            <Availability
                              loadingAvailability={this.state.loadingAvailability}
                              availabilities={this.state.availabilities}
                              start_time={this.props.prestation.ordered_start_time}
                              end_time={this.props.prestation.ordered_end_time}
                              handleChangeAvailability={this.handleChangeAvailability}
                              handleTimeChange={this.handleTimeChange}
                            />
                          </div>
                          : undefined
                      }

                      <div
                        className={
                          !this.props.prestation.uid &&
                          !this.props.prestation.invoice_only_additional_services
                            ? 'col-xs-8'
                            : 'col-xs-offset-2 col-xs-9'
                        }
                      >
                        {
                          this.props.prestation.interpreters.length
                            ? <React.Fragment>
                              <Subheader
                                style={styles.subHeader}
                              >
                                {this.props.prestation.interpreters.length} {this.props.intl.formatMessage(constants.messages.PRESTATION_INTERPRETERS)}

                                {
                                  moment(this.props.prestation.ordered_date) > moment() &&
                                  this.props.prestation.interpreter_travelled
                                    ? <React.Fragment>
                                      <br/>
                                      <div style={{
                                          color: deepOrange500,
                                          ...styles.fontText
                                        }}
                                      >
                                      </div>
                                    </React.Fragment>
                                    : undefined
                                }
                              </Subheader>

                              <div
                                style={{
                                  ...styles.scrollable,
                                  maxHeight: this.props.formVisible ? 420 : 600
                                }}
                              >
                                {
                                  this.props.prestation.interpreters.map((interpreter, index) => {
                                    let interpreterName = interpreter.title
                                      ? interpreter.title + ' ' + interpreter.first_name + ' ' + interpreter.last_name
                                      : interpreter.first_name + ' ' + interpreter.last_name

                                    interpreterName = interpreter.is_backup ? interpreterName + ' * ' : interpreterName

                                    return (
                                      <ListItem
                                        key={index}
                                        initiallyOpen={false}
                                        primaryTogglesNestedList={true}
                                        innerDivStyle={{padding: '10px 70px 10px 10px', height: 40}}
                                        primaryText={
                                          <React.Fragment>
                                            <div className='row'>
                                              <div
                                                className='col-xs-7'
                                                style={{
                                                  textAlign: 'start',
                                                  color: interpreter.is_backup
                                                    ? colors.primary2Color
                                                    : undefined,
                                                  ...styles.fontText,
                                                }}
                                              >
                                                {interpreterName}
                                              </div>

                                              <div
                                                className='col-xs-4'
                                                style={{
                                                  textAlign: 'end',
                                                  ...styles.fontText
                                                }}
                                              >

                                              {
                                                !this.props.prestation.invoice_only_additional_services
                                                  ? <React.Fragment>
                                                    {interpreter.distance} {this.props.intl.formatMessage(constants.messages.DISTANCE_LABEL)}
                                                  </React.Fragment>
                                                  : undefined
                                              }

                                              </div>
                                              <div
                                                className='col-xs-1'
                                                style={{
                                                  textAlign: 'end',
                                                  ...styles.fontText
                                                }}
                                              >
                                                <Checkbox
                                                  labelStyle={styles.fontText}
                                                  onClick={(event) => this.handleToggleSelected(event, interpreter)}
                                                  checked={interpreter.selected}
                                                  disabled={!!this.props.prestation.uid}
                                                />
                                              </div>
                                            </div>
                                            <div className='row'>
                                              <div
                                                style={styles.secondaryText}
                                                className='col-xs-12'
                                              >
                                                {interpreter.language_value_set.join(' - ') + ', ' + interpreter.nationality_origin}
                                              </div>
                                            </div>
                                          </React.Fragment>
                                        }
                                        nestedItems={[
                                          <ListItem
                                            innerDivStyle={{padding: 5, marginLeft: 0}}
                                            style={styles.listItem}
                                            key={1}
                                            primaryText={
                                              <div>
                                                <div className='row'>
                                                  <div className='col-md-12 col-xs-12'>
                                                    <FontIcon
                                                      className='material-icons'
                                                      style={styles.icon}
                                                    >
                                                    email
                                                    </FontIcon>
                                                    {
                                                      interpreter.emails
                                                        ? <div style={styles.textIcon}>
                                                          {interpreter.emails.split(',').join(', ')}
                                                        </div>
                                                        : undefined
                                                    }
                                                  </div>
                                                </div>

                                                <div className='row'>
                                                  <div className='col-md-offset-7 col-md-5 col-xs-12'>
                                                    {
                                                      interpreter.qualifications.length > 0
                                                        ? <div style={{textAlign: 'end'}}>
                                                          {interpreter.qualifications.join(', ')}
                                                        </div>
                                                        : undefined
                                                    }
                                                  </div>
                                                </div>

                                                <div className='row'>
                                                  <div className='col-md-7 col-xs-12'>
                                                    <FontIcon
                                                      className='material-icons'
                                                      style={styles.icon}
                                                    >
                                                    call
                                                    </FontIcon>
                                                    {
                                                      interpreter.phone_numbers
                                                        ? <div style={styles.textIcon}>
                                                          {interpreter.phone_numbers.split(',').join(', ')}
                                                        </div>
                                                        : undefined
                                                    }
                                                  </div>

                                                  <div className='col-md-5 col-xs-12'>
                                                    {
                                                      interpreter.nationality_origin
                                                        ? <div style={{textAlign: 'end'}}>
                                                          {interpreter.nationality_origin}
                                                        </div>
                                                        : undefined
                                                    }
                                                  </div>
                                                </div>

                                                {
                                                  interpreter.is_backup
                                                    ? <div className='row'>
                                                      <div
                                                        className='col-md-12 col-xs-12'
                                                      >
                                                        * Interprète de renfort
                                                      </div>
                                                    </div>
                                                    : undefined
                                                }
                                              </div>
                                            }
                                          />
                                        ]}
                                      />
                                    )
                                  })
                                }
                              </div>
                            </React.Fragment>
                            : <div
                              style={{
                                height: '64%',
                                alignItems: 'center',
                                paddingTop: '25%',
                                textAlign: 'center',
                                color: red500,
                              }}
                            >
                              <div
                                className='col-xs-12'
                              >
                                {this.props.intl.formatMessage(constants.messages.INTERPRETER_UNAVAILABLE_TIME1)}
                              </div>
                              <div
                                className='col-xs-12'
                                style={{paddingTop: 15}}
                              >
                                {this.props.intl.formatMessage(constants.messages.INTERPRETER_UNAVAILABLE_TIME2)}
                                <a
                                  href={"mailto:" + constants.MAIL_TO}
                                  style={{color: red500}}
                                >
                                  {constants.MAIL_TO}
                                </a>
                                {this.props.intl.formatMessage(constants.messages.INTERPRETER_UNAVAILABLE_TIME3)}
                              </div>
                            </div>
                        }
                      </div>
                    </React.Fragment>
                }
              </div>
            </React.Fragment>
        }
      </Card>
    )
  }
}

const styles = {
  card: {
    marginTop: 5,
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5
  },
  listItem: {
    backgroundColor: '#2196F3',
    color: 'white',
    fontSize: 14
  },
  subHeader: {
    textAlign: 'center',
    lineHeight: '20px',
    paddingTop: 10
  },
  icon: {
    float: 'left',
    marginRight: 10,
    color: 'white'
  },
  textIcon: {
    lineHeight: '24px'
  },
  scrollable: {
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingLeft: 15,
    maxHeight: 550
  },
  fontText: {
    fontSize: 14
  },
  secondaryText: {
    fontSize: 14,
    color: '#0000008a'
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

export default connect(
  mapStateToProps,
  undefined
)(injectIntl(InterpreterList))



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/InterpreterList.js